// Array of students' games
export const games = [
    {
      title: `Turkey Trot`,
      author: `Bennett M.`,
      description: `Help the turkey find his way through the maze and past the obstacles. Before you know it, he'll be gobbling for victory at the end of the map!`,
      link: `https://makecode.com/_CALCuVach2Uz`,
      image: `images/gobbles.gif`,
      protagonist: `Gobbles`,
      genre: `Action-adventure`,
      term: `Fall 2020`,
    },
    {
      title: `Wizard Vs. Witches`,
      author: `Zahid I.`,
      description: `Help Merlin get to the big chest at the other side that is guarded by snakes, bats, and witches. Make sure to collect tiny chests on the way to get points. Watch out there are many booby traps!`,
      link: `https://makecode.com/_TFmYtHRwK2Kc`,
      image: `images/Merlin.gif`,
      protagonist: `Merlin`,
      genre: `Action-adventure`,
      term: `Fall 2020`,
    },
    {
      title: `Dodge and weave`,
      author: `Bennett M.`,
      description: `In dodge and weave you need to dodge all of the projectiles for 2 minutes. Bones and spears will come flying at you throught the game. There are three different levels with different mechanics. Have fun!`,
      link: `https://makecode.com/_fhzW78HARi86`,
      image: `images/index.gif`,
      protagonist: `Heart`,
      genre: `survival`,
      term: `Fall 2020`,
    },
  {
      title: `Messi Soccer`,
      author: `Abbey S.`,
      description: `Get Messi to the Golden Goal without getting destroyed by Ronaldo. Collect the soccer balls for points.`,
      link: `https://makecode.com/_8gXXmYRt0Dh5`,
      image: `images/messi.gif`,
      protagonist: `Messi`,
      genre: `Sports-Adventure`,
      term: `Fall 2020`
    },
    {
      title: `Airships Galore`,
      author: `Marko M-K`,
      description: `Airships Galore is a platformer game based om the airship levels from Super Mario. The game's protagonist name is Ludwig and he is fighting his entire Airshipp fleet just to get better wages.`,
      link: `https://makecode.com/_15W3MXLzoCKj`,
      image: `images/download.gif`,
      protagonist: `Ludwig`,
      genre: `Platformer`,
      term: `Fall 2020`,
    },
     {
        title: `Zombie Invasion`,
        author: `Aadi P.`,
        description: `Run around the street killing zombies to earn points. More and more zombies spawn in as time goes on so make sure you use your lives wisely.`,
        link: `https://makecode.com/_4P7L8aWAq46F`,
        image: `images/davethedj.gif`,
        protagonist: `Dave The DJ`,
        genre: `Action`,
        term: `Fall 2020`,
    },
    {
      title: `Valkyrie Flappy Bird`,
      author: `Virginia W.`,
      description: `Help the Valkyrie fly through absticles.Collect hammers as you go and reach Odin at the end.`,
      link: `https://makecode.com/_Lh28L57H5F0r`,
      image: `images/vfb.gif`,
      protagonist: `Valkyrie`,
      genre: `Adventure`,
      term: `Fall 2020`,
    },
    {
      title: `Ballard's Birds`,
      author: `Dominguez`,
      description: `Ballard's Birds is a platformer game that puts you in control of the fearless Mr. Ballard. Help him destroy flocks of birds, grab some jambalaya, and rescue sweet Rosie.`,
      link: `https://makecode.com/_YWXdPbRmMCyj`,
      image: `images/bbgif.gif`,
      protagonist: `Mr. Ballard`,
      genre: `Platformer`,
      term: `Fall 2020`,
    },
  ];
     
  
